import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../components/Header.css';
import logoImage from '../assets/LogoHypothesisGames.webp';

function Header() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <header className="transparent-header">
      <nav className="header-nav">
        <Link 
          to="/upcoming" 
          className={`${location.pathname === "/upcoming" ? "nav-link-violet" : "nav-link-blue"} ${isHome ? "pulse-animation" : ""}`}
        >
          New Releases
        </Link>

        <Link to="/" className="logo-link">
          {isHome ? (
            <span className={location.pathname === "/" ? "nav-link-violet" : "nav-link-blue"}>
              HYPOTHESIS GAMES
            </span>
          ) : (
            <img 
              src={logoImage} 
              alt="Hypothesis Games" 
              className="header-logo"
            />
          )}
        </Link>

        <Link 
          to="/catalog" 
          className={`${location.pathname === "/catalog" ? "nav-link-violet" : "nav-link-blue"} ${isHome ? "pulse-animation" : ""}`}
        >
          Our products
        </Link>
      </nav>
    </header>
  );
}

export default Header;